import { UI } from '../lib/ui.js'
export class Accordion {
    constructor(){
        const ui = window.ui ? window.ui : new UI
        this.wrapper = ui.element('div',{class:'accordion'})
        return this.wrapper
    }
    add(item) {
        if(Array.isArray(item))
            return this.addGroup(item)
    }
    addGroup(items) {

    }
}